import { Pressable, SafeAreaView, Text, ViewStyle } from "react-native";
import LinearGradient from "react-native-linear-gradient";
import { color_main, white } from "../assets/style/colors";
import React from "react";

interface BottomButtonProps {
  text: string;
  style?: ViewStyle;
  contentStyle?: ViewStyle;
  onClick?: () => void;
}

export const BottomButtonView = ({
  text,
  onClick,
  style,
  contentStyle,
}: BottomButtonProps) => {
  return (
    <SafeAreaView
      style={[
        {
          backgroundColor: "white",
          alignItems: "center",
          justifyContent: "center",
          paddingHorizontal: 16,
        },
        style,
      ]}
    >
      <Pressable
        onPress={onClick}
        style={[
          {
            paddingTop: 16,
            paddingBottom: 24,
            flexDirection: "row",
            width: "100%",
          },
          contentStyle,
        ]}
        android_ripple={{ color: 'rgba(0, 0, 0, 0.1)' }}
      >
        <LinearGradient
          colors={[color_main, color_main]}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 0 }}
          style={{
            paddingVertical: 16,
            alignItems: "center",
            justifyContent: "center",
            flex: 1,
            flexDirection: "row",
            borderRadius: 28,
            shadowColor: color_main,
            shadowOffset: {
              width: 0,
              height: 4,
            },
            shadowOpacity: 0.2,
            shadowRadius: 8,
            elevation: 5,
          }}
        >
          <Text
            style={{
              color: white,
              fontSize: 18,
              fontWeight: "600",
              textAlign: "center",
              flex: 1,
              letterSpacing: 0.5,
            }}
          >
            {text}
          </Text>
        </LinearGradient>
      </Pressable>
    </SafeAreaView>
  );
};
